// src/pages/TerminosCondiciones.js
import React from 'react';
import "./LegalPages.css";
import { Link } from 'react-router-dom';

function TerminosCondiciones() {
  return (
    <div className="legal-page">
      <h1>TÉRMINOS Y CONDICIONES - SANTO DOMINGO ESPECTÁCULOS</h1>
      <p>Bienvenido a Santo Domingo Espectáculos.</p>
      <p>Al utilizar nuestro servicio, usted acepta cumplir con los términos y condiciones establecidos a continuación.</p>
      <p>Si no está de acuerdo con estos términos y condiciones, por favor no utilice nuestro sitio web.</p>
      
      <h2>1. Servicios ofrecidos</h2>
      <p>Santo Domingo Espectáculos ofrece un servicio en línea que permite la compra de boletos para eventos. Nos aseguramos de proporcionar información precisa sobre los eventos ofertados, pero nos reservamos el derecho de modificar cualquier información en nuestro sitio web en cualquier momento sin previo aviso.</p>
      
      <h2>2. Precios y pagos</h2>
      <p>Los precios de los boletos mostrados en nuestro sitio web incluyen todos los impuestos y tarifas aplicables. Nos reservamos el derecho de cambiar los precios de los boletos en cualquier momento sin previo aviso.</p>
      <p>Los pagos se procesarán a través de nuestros proveedores de servicios de pago seguros.</p>
      <p>Para más detalles, por favor lea nuestras <Link to="/politica-seguridad">Políticas de Seguridad</Link>.</p>
      
      <h2>3. Entrega de boletos</h2>
      <p>Los boletos se enviarán automáticamente por correo electrónico una vez que se haya procesado el pago con éxito.</p>
      <p>Nos esforzamos por procesar los pedidos lo más rápido posible, pero no garantizamos un plazo de entrega específico.</p>
      <p>Para más detalles, por favor lea nuestras <Link to="/politica-entrega">Políticas de Entrega</Link>.</p>
      
      <h2>4. Devoluciones y Cancelaciones</h2>
      <p>Los boletos comprados a través de nuestro sitio web no son reembolsables ni transferibles.</p>
      <p>Si un evento es cancelado o pospuesto, haremos todo lo posible por proporcionar información actualizada sobre el proceso de reembolso o reprogramación de los boletos.</p>
      <p>Para más detalles, por favor lea nuestras <Link to="/politica-devoluciones">Políticas de Devoluciones y Cancelaciones</Link>.</p>
      
      <h2>5. Derechos de propiedad intelectual</h2>
      <p>Todos los contenidos en nuestro sitio web, incluidos los textos, gráficos, logotipos, iconos, imágenes y software, son propiedad exclusiva de Santo Domingo Espectáculos o de sus proveedores de contenido y están protegidos por las leyes de propiedad intelectual.</p>
      <p>Está prohibido copiar, distribuir o modificar cualquier contenido sin autorización previa.</p>
      
      <h2>6. Limitación de responsabilidad</h2>
      <p>En ningún caso Santo Domingo Espectáculos será responsable por daños directos, indirectos, incidentales o consecuentes que surjan del uso o la imposibilidad de uso de nuestro sitio web o de la información proporcionada en él.</p>
      <p>Asimismo, no nos hacemos responsables por daños, pérdidas o inconvenientes que puedan ocurrir en los eventos ofertados a través de nuestra plataforma.</p>
      
      <h2>Contacto</h2>
      <p>Si tiene alguna pregunta o inquietud sobre estos términos y condiciones, puede comunicarse con nosotros a través de nuestros canales oficiales.</p>
    </div>
  );
}
export default TerminosCondiciones;
